<div class="modal-header" cdkDrag cdkDragRootElement=".modal-content" cdkDragHandle>
  <h5 class="modal-title">Reallocate Tasks</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
</div>

<div class="modal-body">
  <form autocomplete="off">

    <!-- Paralegal -->
    <div *ngIf="taskType == 'paralegal'">
      <div class="mb-3" *ngIf="paralegalUsers && paralegalUsers.length != 0">
        <label class="form-label">Paralegal</label>
        <div class="dropdown" ngbDropdown #paralegalDropdown="ngbDropdown">
          <input type="text"
                 class="form-control"
                 placeholder="Type to search paralegal..."
                 (focus)="paralegalDropdown.open()"
                 (input)="filterParalegalUsers($event); paralegalDropdown.open()"
                 [value]="selectedParalegalUserName">
          <div class="dropdown-menu w-100" ngbDropdownMenu style="max-height: 300px; overflow-y: auto;">
            <button type="button"
                    class="dropdown-item"
                    *ngFor="let user of filteredParalegalUsersList"
                    (click)="selectParalegal(user); paralegalDropdown.close()">
              {{user.name}}
            </button>
            <div class="dropdown-item text-muted" *ngIf="filteredParalegalUsersList.length === 0">
              No users found
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Admin -->
    <div *ngIf="taskType == 'admin'">
      <div class="mb-3" *ngIf="adminUsers && adminUsers.length != 0">
        <label class="form-label">Admin</label>
        <div class="dropdown" ngbDropdown #adminDropdown="ngbDropdown">
          <input type="text"
                 class="form-control"
                 placeholder="Type to search admin..."
                 (focus)="adminDropdown.open()"
                 (input)="filterAdminUsers($event); adminDropdown.open()"
                 [value]="selectedAdminUserName">
          <div class="dropdown-menu w-100" ngbDropdownMenu style="max-height: 300px; overflow-y: auto;">
            <button type="button"
                    class="dropdown-item"
                    *ngFor="let user of filteredAdminUsersList"
                    (click)="selectAdmin(user); adminDropdown.close()">
              {{user.name}}
            </button>
            <div class="dropdown-item text-muted" *ngIf="filteredAdminUsersList.length === 0">
              No users found
            </div>
          </div>
        </div>
      </div>
    </div>

  </form>
</div>

<div class="modal-footer">
  <ng-container *ngIf="!saving">
    <button type="button" class="btn btn-success" [disabled]="invalidSelection"
      (click)="taskType == 'paralegal' ? reallocateParalegalTasks() : reallocateAdminTasks()">Save</button>
  </ng-container>

  <button *ngIf="saving" type="button" class="btn btn-outline-success" disabled>
    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
    Saving...
  </button>
</div>